import React, { useState, useEffect } from "react";

import { Button, Grid, Typography } from "@mui/material";
import { RoomOutlined, SensorDoorOutlined } from "@mui/icons-material";

import { PageStandard } from "components/admin/PageStandard";
import { useUserContext } from "contexts/UserContext";
import { ElectricalPanelTypes } from "api/automationTypes";
import { BlockStandard } from "components/admin/BlockStandard";
import { createElectricPanel, fetchPanelTypes } from "api/automation";
import { useSetError } from "contexts/ErrorContext";
import { CustomCodes, ErrorResponse } from "contexts/ErrorContextData";
import {
  ElectricalPanelDetail,
  ElectricalPanelDetailItem,
  emptyElectricalPanel,
} from "components/forms/ElectricalPanelDetail";

export const CreateElectricalPanel = ({ history }) => {
  const { token, currentSpace, currentEnvironment } = useUserContext();
  const setError = useSetError();

  const [panelOptions, setPanelOptions] = useState<ElectricalPanelTypes[]>([]);
  const [panelsData, setPanelsData] = useState<ElectricalPanelDetailItem[]>([
    { ...emptyElectricalPanel },
  ]);

  useEffect(() => {
    const getTypesList = async () => {
      try {
        const data = await fetchPanelTypes(token);
        setPanelOptions(data || []);
      } catch (error) {
        setError(error as ErrorResponse);
      }
    };
    getTypesList();
  }, [token, setError]);

  const handleSubmit = async () => {
    if (!panelsData?.length || !currentEnvironment?.id || !currentSpace?.id) {
      setError(CustomCodes.INCOMPLETE_FORM);
      return;
    }

    try {
      await createElectricPanel(token, currentEnvironment.id, panelsData);
      history.goBack();
    } catch (error) {
      setError(error as ErrorResponse);
    }
  };

  const handleAdd = () => {
    setPanelsData((prev) => [...prev, { ...emptyElectricalPanel }]);
  };

  const handlePanelUpdate = (
    updatedPanel: ElectricalPanelDetailItem,
    position: number
  ) => {
    if (panelsData?.length) {
      const updated = [...panelsData];
      updated.splice(position, 1, updatedPanel);
      setPanelsData(updated);
    }
  };

  const handlePanelDelete = (position: number) => {
    const updated = [...panelsData];
    updated.splice(position, 1);
    setPanelsData(updated);
  };

  return (
    <PageStandard title="Quadro elétrico" onAdd={handleAdd}>
      <BlockStandard hideDivider>
        <Grid item container alignItems="center">
          <RoomOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentSpace?.schoolName}</Typography>
          <SensorDoorOutlined sx={{ mr: 0.5 }} color="secondary" />
          <Typography sx={{ mr: 3 }}>{currentEnvironment?.name}</Typography>
        </Grid>
      </BlockStandard>

      {!!panelsData?.length &&
        panelsData.map((panel, position) => (
          <ElectricalPanelDetail
            key={position}
            data={panel}
            position={position}
            panelOptions={panelOptions}
            onChange={(updated) => handlePanelUpdate(updated, position)}
            onDelete={() => handlePanelDelete(position)}
          />
        ))}

      {!!panelsData?.length && (
        <Button variant="contained" onClick={handleSubmit}>
          Atualizar dados de quadro elétrico
        </Button>
      )}
    </PageStandard>
  );
};
